import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { ACTIVITY_TYPES, Movement, MovementOut, MovementType } from "../models/Movement";

export default class MovementApi{

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string){
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getMovements(pkCuaa: number, warehouseId: number, itemId: number, stockedLotNumber: string | null, paging: PagingParams, sortDesc: boolean): Promise<PagedResults<Movement>>{
        const url = `${this.rootPath}/v1/warehouse/subjects/${pkCuaa}/warehouses/${warehouseId}/stocks`;
        const filterArr = [];
        filterArr.push(`item_id eq ${itemId}`);
        if (stockedLotNumber) {
             filterArr.push(`stocked_lot_number eq ${stockedLotNumber}`);
        } else {
             filterArr.push(`stocked_lot_number eq `);
        }
        const params = {
            filter: filterArr,
            count: paging.count,
            offset: paging.offset,
            sort: sortDesc ? '-operation_date' : '+operation_date',
        }
        const res = await this.http.get(url, {params});
        propsToDatePaged(res.data, ["operation_date"])
        res.data.records.forEach((mv: Movement) => {
            mv.delivery_notes.forEach(dn => propsToDate(dn, ["dn_date"]))
        });
        return res.data;
    }

    public async getMovementsType(): Promise<MovementType[]>{
        const url = `${this.rootPath}/v1/warehouse/dictionary/operation_types`;
        const params = {
            count: 300,
            offset: 0
        }
        const res = await this.http.get(url, {params});
        res.data = [... res.data, ...ACTIVITY_TYPES];
        return res.data;
    }

    public async deleteMovement(pkCuaa: number, warehouseId: number, itemId: number): Promise<Movement> {
        const res = await this.http.delete(`${this.rootPath}/v1/warehouse/subjects/${pkCuaa}/warehouses/${warehouseId}/stock_movement/${itemId}`);
        return res.data;
    }

    public async editMovement(pkCuaa: number, warehouseId: number, itemId: number, detailOut: MovementOut): Promise<Movement> {
        const res = await this.http.put(`${this.rootPath}/v1/warehouse/subjects/${pkCuaa}/warehouses/${warehouseId}/stock_movement/${itemId}`, detailOut);
        return res.data;
    }

}
